export default {
  Groups: {
    searchSelect: ['name', 'description'],
    notSelectSearch: 'dynamicEntities',
    expand: {
      dynamicEntities: { count: true },
    },
  },

  Entities: {
    select: 'id,displayName,description,order,isActive,isPremiumEntity',
    searchSelect: ['displayName', 'description'],
    notSelectSearch: 'order,dynamicEntities',
    expand: {
      dynamicEntityGroup: { select: 'name' },
    },
    orderBy: 'order',
  },

  Favorites: {
    select: 'id,displayName,description,order,isActive,isPremiumEntity',
    expand: {
      dynamicEntityGroup: { select: 'name' },
    },
    orderBy: 'order',
  },
  EntityDetail: {},

  PremiumEntities: {
    select: 'id,displayName,description,order,isActive,isPremiumEntity',
    searchSelect: ['displayName', 'description'],
    notSelectSearch: 'order,dynamicEntities',
    filter: 'isPremiumEntity eq true',
    expand: {
      dynamicEntityGroup: { select: 'name' },
    },
    orderBy: 'order',
  },
};
